export const cloneCacheValue = <T>(value: T): T => {
  if (value === null || value === undefined) {
    return value;
  }

  const structuredCloneFn =
    typeof window !== 'undefined' ? (window as any).structuredClone : undefined;

  if (typeof structuredCloneFn === 'function') {
    try {
      return structuredCloneFn(value);
    } catch {
      // Fall back for values structuredClone cannot copy.
    }
  }

  const serialized = JSON.stringify(value);
  return serialized === undefined ? value : JSON.parse(serialized);
};

export const isMutationSuccess = (data: any): boolean => !data || !data.error;

export const toPositiveNumber = (value: any): number | undefined => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
};

export const firstPositiveNumber = (...values: any[]): number | undefined => {
  for (const value of values) {
    const parsed = toPositiveNumber(value);
    if (parsed !== undefined) {
      return parsed;
    }
  }
  return undefined;
};
